(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    /* CUSTOM (Moss & Molt): hover-to-play video on product cards */
  (function () {
    function cardVideos(gallery) {
      return gallery.querySelectorAll('video.card-gallery__hover-video');
    }

    // Start downloading a card's video ahead of time so the hover is smooth
    function warmUp(video) {
      if (video.dataset.warmed) return;
      video.dataset.warmed = '1';
      video.preload = 'auto';
      video.load();
    }

    // Oct 20 2026 (site weight sweep, David's call): no more preloading every card's video as it scrolls near the
    // screen. Measured on the live site, that pulled 21 MB on the home page, 9 MB on Shop All and 6 MB on the cart
    // page (its recommendation cards) in desktop Chrome before anyone hovered. A card's clip now downloads on the
    // first hover (warmUp below); at 480p that is about a second on a normal connection.

    document.addEventListener('pointerover', function (event) {
      if (event.pointerType === 'touch') return;
      var gallery = event.target.closest && event.target.closest('.card-gallery');
      if (!gallery || gallery.contains(event.relatedTarget)) return;
      cardVideos(gallery).forEach(function (video) {
        warmUp(video);
        video.muted = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      });
    });

    /* CUSTOM (Moss & Molt, Oct 18 2026): the phone play button (see the markup comment) */
    function mmStop(gallery) {
      var video = gallery.querySelector('video.mm-card-vid');
      if (video) {
        video.pause();
        video.remove();
      }
      delete gallery.dataset.mmPlaying;
      var button = gallery.querySelector('.mm-card-play');
      if (button) {
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', button.dataset.labelPlay || 'Play video');
      }
    }

    var mmSeen =
      'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting && entry.target.dataset.mmPlaying) mmStop(entry.target);
            });
          })
        : null;

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest && event.target.closest('.mm-card-play');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        var gallery = button.closest('.card-gallery');
        if (!gallery) return;
        if (gallery.dataset.mmPlaying) {
          mmStop(gallery);
          return;
        }
        document.querySelectorAll('.card-gallery[data-mm-playing]').forEach(mmStop);
        var video = document.createElement('video');
        video.className = 'mm-card-vid';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-hidden', 'true');
        if (button.dataset.poster) video.poster = button.dataset.poster;
        video.src = button.dataset.src;
        gallery.appendChild(video);
        gallery.dataset.mmPlaying = '1';
        button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-label', button.dataset.labelStop || 'Stop video');
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
        if (mmSeen) mmSeen.observe(gallery);
      },
      true
    );

    // swiping the card's pictures stops its video
    document.addEventListener(
      'scroll',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        var gallery = target.closest('.card-gallery[data-mm-playing]');
        if (gallery) mmStop(gallery);
      },
      true
    );

    document.addEventListener('pointerout', function (event) {
      var gallery = event.target.closest && event.target.closest('.card-gallery');
      if (!gallery || gallery.contains(event.relatedTarget)) return;
      cardVideos(gallery).forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
